import { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react'
import styles from './index.module.scss'
import API, { commonApiInvoker } from '@api/api'
import { Button, Divider, Empty, Image, Input, message, Select, Space, Spin, Checkbox, Radio } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { useLocation } from 'react-router-dom'
import { flushSync } from 'react-dom'
const _ = require('lodash')
const searchOptions = [{
    label: '批次',
    value: 'version',
}, {
    label: '货号',
    value: 'skuCode',
}]
const statusOptions = virtual => [{
    label: '全部商品状态',
    value: 'all',
}, {
    label: '已选图',
    value: 2,
}, {
    label: '待选图',
    value: 1,
}, {
    label: virtual == 0 ? '待拍摄' : '待传底片',
    value: 0,
}]

const DeliveryItem = ({item, onClick, virtual}) => {
    // 0待拍摄/待传底片 1待选图 2已选图
    const status = useMemo(() => {
        if(item.status == 0) {
            return {
                text: virtual == 0 ? '待拍摄' : '待传底片',
                className: styles.status0
            }
        } else if(item.status == 1) {
            return {
                text: '待选图',
                className: styles.status1
            }
        } else if(item.status == 2) {
            return {
                text: '已选图',
                className: styles.status2
            }
        }
    }, [virtual])
    return (
        <div className={styles.DeliveryItem} onClick={() => onClick(item)}>
            {item.photoImage ?
            <Image
                rootClassName={styles.ImageItem}
                src={item.photoImage + '?&x-oss-process=style/thumbnail-width-300'}
                preview={false}
                fallback={require('@assets/images/fallback.png')}
            /> :
            <div className={styles.NoShoot}>
            {virtual == 0 ? '待拍摄' : '待传底片'}
            </div>}
            <p className={styles.NameLabel}>{item.skuCode || item.skuNumber}</p>
            <div className={`${styles.Status} ${status.className}`}>{status.text}</div>
        </div>
    )
}

const DeliveryDetail = forwardRef(({ version, searchText, onSkuClick, virtual }, ref) => {
    useImperativeHandle(ref, () => ({
        updateForce: () => updateForce({}),
    }))

    const [dataSource, setDataSource] = useState([])
    const [force, updateForce] = useState()
    const [status, setStatus] = useState('all')

    useEffect(() => {
        if (!version) return
        const params = new URLSearchParams()
        params.append('deliveryVersion', version)
        commonApiInvoker(API.getCaptureDeliverySku(params)).then(res => {
            setDataSource(res || [])
        })
    }, [version, force])
    // 筛选数据
    const displayDataSource = useMemo(() => {
        const filterDataSource = searchText ? dataSource.filter(item => item.skuCode == searchText) : dataSource
        if(status == 'all') {
            return filterDataSource
        }
        return filterDataSource.filter(item => item.status == status)
    }, [dataSource, searchText, status])
    // 点击sku
    const skuClick = useCallback((item) => {
        // 0待拍摄/待传底片 1待选图 2已选图
        const {status} = item
        if(status == 0) {
            if (virtual == 0) message.warning('暂未拍摄！')
            else if (virtual == 3) message.warning('暂未上传底片！')
            else message.warning('暂无数据！')
            return false
        }
        onSkuClick(item, version, virtual)
    }, [onSkuClick, virtual, version])
    return (
        <div className={styles.DeliveryDetail}>
            <div className={styles.DeliveryDetailTitle}>
                {version}
            </div>
            <div>
                <Select
                    style={{width: 126}}
                    classNames={{
                        root: styles.SearchSelect,
                        popup: {
                            root: styles.SearchSelectPopup
                        }
                    }}
                    options={statusOptions(virtual)}
                    value={status}
                    onChange={setStatus}
                />
            </div>
            <div id="scrollableDiv" className={`${styles.DeliveryDetailContent} _beauty_scrollbar`}>
                <div className={styles.DeliveryItemList}>
                {
                    displayDataSource.map(item => (
                        <DeliveryItem
                            key={item.id}
                            item={item}
                            virtual={virtual}
                            onClick={skuClick}
                        />
                    ))
                }
                </div>
            </div>
        </div>
    )
})

export default function VersionAndSkuList (props) {
    const refs1 = useRef([])
    const refs2 = useRef([])
    const [versionText, setVersionText] = useState()
    const [originalVersionList, setOriginalVersionList] = useState([]) // 原始数据
    const [processVersionList, setProcessVersionList] = useState([]) // 进行中
    const [completedVersionList, setCompletedVersionList] = useState([]) // 已完成
    const [displayProcessVersionList, setDisplayProcessVersionList] = useState([])
    const [displayCompletedVersionList, setDisplayCompletedVersionList] = useState([])
    const initRef = useRef(false)

    const [loading, setLoading] = useState(false)
    const updateAndscrollIntoView = useCallback(_.debounce((version, list1, list2, block="nearest") => {
        // 使用 requestAnimationFrame 确保在下一帧执行
        requestAnimationFrame(() => {
            // 确保 DOM 立即更新
            flushSync(() => {
                setDisplayProcessVersionList(list1)
                setDisplayCompletedVersionList(list2)
            })
            if (version) {
                setVersionText(version)
                if (list1.includes(version)) {
                    refs1.current[list1.indexOf(version)]?.scrollIntoView({
                        behavior: 'smooth',
                        block: block
                    })
                } else if (list2.includes(version)) {
                    refs2.current[list2.indexOf(version)]?.scrollIntoView({
                        behavior: 'smooth',
                        block: block
                    })
                }
            } else {
                setVersionText()
            }
            initRef.current = true
        })
    }, 300), [])
    useEffect(() => {
        const params = new URLSearchParams()
        setLoading(true)
        commonApiInvoker(API.getMerchantCaptureDeliveryVersion(params), false, true).then(res => {
            const processVersionList = (res || []).filter(item => item.status === 0).map(item => item.deliveryVersion)
            const completedVersionList = (res || []).filter(item => item.status === 1).map(item => item.deliveryVersion)
            setOriginalVersionList(res || [])
            setProcessVersionList(processVersionList)
            setCompletedVersionList(completedVersionList)
            
            console.log('props.version', props.version)
            const version = props.version || [...processVersionList, ...completedVersionList]?.[0]
            updateAndscrollIntoView(version, processVersionList, completedVersionList)
        }).catch((err) => {
            console.error(err)
        }).finally(() => {
            setLoading(false)
        })
    }, [])

    // 搜索
    const [searchText, setSearchText] = useState()
    const [searchTarget, setSearchTarget] = useState("version")
    const handleSearchChangeDebounce = useCallback(_.debounce((value) => {
        const searchText = value.trim()
        setSearchText(searchText)
    }, 500), [searchTarget, processVersionList, completedVersionList])
    const handleSearchChange = useCallback((e) => {
        handleSearchChangeDebounce(e.target.value)
    }, [handleSearchChangeDebounce])
    useEffect(() => {
        if (!initRef.current) return
        if (!searchText) {
            setDisplayProcessVersionList(processVersionList)
            setDisplayCompletedVersionList(completedVersionList)
        } else {
            if (searchTarget === "version") {
                const displayProcessVersionList = processVersionList.filter(item => item.includes(searchText))
                const displayCompletedVersionList = completedVersionList.filter(item => item.includes(searchText))
                const version = [...displayProcessVersionList, ...displayCompletedVersionList]?.[0]
                updateAndscrollIntoView(version, displayProcessVersionList, displayCompletedVersionList)
            } else {
                const params = new URLSearchParams()
                params.append("skuCode", searchText)
                commonApiInvoker(API.getMerchantCaptureDeliveryVersion(params), false, true).then(res => {
                    console.log('res', res)
                    const processVersionList = (res || []).filter(item => item.status === 0).map(item => item.deliveryVersion)
                    const completedVersionList = (res || []).filter(item => item.status === 1).map(item => item.deliveryVersion)
                    const version = [...processVersionList, ...completedVersionList]?.[0]
                    updateAndscrollIntoView(version, processVersionList, completedVersionList)
                }).catch((err) => {
                    console.error(err)
                })
            }
        }
    }, [searchText, searchTarget, processVersionList, completedVersionList])

    // 当前批次的类型
    const virtual = useMemo(() => {
        return originalVersionList.find(item => item.deliveryVersion === versionText)?.virtual
    }, [originalVersionList, versionText])

    return (
        <div className={styles.VersionAndSkuList}>
            <div className={styles.LeftContainer}>
                <div className={styles.SearchBox}>
                    <Space.Compact>
                        <Select
                            classNames={{
                                root: styles.SearchSelect,
                                popup: {
                                    root: styles.SearchSelectPopup
                                }
                            }}
                            options={searchOptions}
                            value={searchTarget}
                            onChange={setSearchTarget}
                        />
                        <Input style={{fontSize: 13}} prefix={<SearchOutlined />} placeholder="搜索" allowClear onChange={handleSearchChange} />
                    </Space.Compact>        
                </div>
                <div className={`${styles.VersionGroup} _beauty_scrollbar`}>
                {
                    (displayProcessVersionList.length > 0 || displayCompletedVersionList.length > 0) ?
                    <>
                    {
                        displayProcessVersionList.length > 0 ?
                        <>
                        <div className={styles.VersionTitle}>待选图</div>
                        <div className={styles.VersionLit}>
                        {displayProcessVersionList.map((item, index) => (
                            <div
                                ref={el => refs1.current[index] = el}
                                key={index}
                                onClick={() => setVersionText(item)}
                                className={`${styles.VersionItem} ${versionText === item ? styles.Active : ''}`}
                            >
                                <span title={item}>{item}</span>
                            </div>
                        ))}
                        </div>
                        </> : null
                    } {
                        displayProcessVersionList.length > 0 && displayCompletedVersionList.length > 0 ?
                        <Divider style={{margin: 0}} /> : null
                    } {
                        displayCompletedVersionList.length > 0 ?
                        <>
                        <div className={styles.VersionTitle}>已选图</div>
                        <div className={styles.VersionLit}>
                        {displayCompletedVersionList.map((item, index) => (
                            <div
                                ref={el => refs2.current[index] = el}
                                key={index}
                                onClick={() => setVersionText(item)}
                                className={`${styles.VersionItem} ${versionText === item ? styles.Active : ''}`}
                            >
                                <span title={item}>{item}</span>
                            </div>
                        ))}
                        </div>
                        </> : null
                    }
                    </> :
                    <div className={styles.Placeholder}>
                    { loading ? <Spin /> : <Empty /> }
                    </div>
                }
                </div>
            </div>
            <div className={styles.RightContainer}>
            {
                versionText ? 
                <DeliveryDetail
                    version={versionText}
                    searchText={searchTarget === "skuCode" ? searchText : ""}
                    virtual={virtual}
                    onSkuClick={props.onSkuClick}
                /> :
                <div className={styles.Placeholder}>
                    <Empty description={false} />
                </div>
            }
            </div>
        </div>
    )
}